module.exports = __webpack_public_path__ + "img/toggle-02-left.42ba3b1b.svg";